import React, { Component, useState, useEffect } from 'react'
import '../styles/Commitment.css'
import xButton from '../images/x-white.png'
import Overlay from '../widgets/Overlay'

class SupplyPlanCommitment extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			clusterId: sessionStorage.getItem("cluster-id"),
			siteId: props.siteId,
			show: false,
			listItems: []
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.show != this.props.show) {
			this.setState({
				show: this.props.show,
				cHeight: (this.props.show)? "100%": "0%",
			});
		}
	}

	render() {
		const c = <div id="supply-plan-commitment">
			{this.state.show && <div id={"spc-header"} style={{background: this.state.bgColor}}>
				<div id="spc-title">ENCODE COMMITMENTS</div>
				<div id="spc-close">
					<img src={xButton} id="x-button" alt="Close" onClick={() => {
						this.props.hide()
					}} />
				</div>
			</div>}
			{this.state.show && <div id={"spc-content"}>
				<div id="spc-table"><div>
					<div id="spc-table-header">
						<div className="cac-name">Farmer Full Name</div>
						<div className="cac-step2-area">STEP 2: Area Planted (has)</div>
						<div className="cac-step2-commitment">STEP 2: Initial Commitment</div>
						<div className="cac-step4">STEP 4: Commitment Yield</div>
						<div className="cac-step6">STEP 6: Forcasted Supply</div>
					</div>
					{this.state.listItems}
					</div>
				</div>
				<div id="spc-buttons">
					<button className="gray" onClick={() => {
						this.setState({
							show: false,
							cHeight: "0%"
						})
					}}>CANCEL</button>
					<button className="green-two">SUBMIT</button>
				</div>
			</div>}
		</div>
		return(<div className="supply-plan-commitment">
			<Overlay content={c} cHeight={this.state.cHeight} />
		</div>)
	}
}


class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			isOn: false,
			areaPlanted: "0.0",
			initialCommitment: "0.0",
			supplyCommitment: "0",
			evaluatedSupply: "0",
			member: {},
			disabled: (props.disabled == null)? true: props.disabled
		}
	}

	componentWillMount() {
		if(this.props.data != null) {
			if(this.props.data.middle_name != null) {
				var mi = this.props.data.middle_name.charAt(0) + "."
			}
			const extn = (this.props.data.extension_name != null)? this.props.data.extension_name: ""
			const name = this.props.data.first_name + " " + mi + " " + this.props.data.last_name + " " + extn
			this.state.member["farmer_id"] = this.props.data.farmer_id
			this.setState({
				regNum: this.props.data.registration_no,
				name: name.toUpperCase(),
				farmerId: this.props.data.farmer_id,
				initialCommitment: (this.props.data.initial_commitment == null)? "0": this.props.data.initial_commitment
			})
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.data != prevProps.data) {
			this.state.member["commitment_id"] = this.props.data.commitment_id
			this.state.member["area_planted"] = (this.props.data.area_planted == null)? "0.0": this.props.data.area_planted
			this.state.member["initial_commitment"] = (this.props.data.initial_commitment == null)? 0: this.props.data.initial_commitment
			this.state.member["supply_commitment"] = (this.props.data.supply_commitment == null)? 0: this.props.data.supply_commitment
			const nm = (this.props.data.supply_commitment >= this.props.data.evaluated_supply)? true: false
			this.setState({
				areaPlanted: (this.props.data.area_planted == null)? "0.0": this.props.data.area_planted,
				initialCommitment: (this.props.data.initial_commitment == null)? 0: this.props.data.initial_commitment,
				supplyCommitment: (this.props.data.supply_commitment == null)? 0: this.props.data.supply_commitment,
				evaluatedSupply: (this.props.data.evaluated_supply == null)? 0: this.props.data.evaluated_supply,
				notMet: nm
			})
		}
	}

	render() {
		const view = <div className="cac-listItem">
			<div className="cac-reg-no li-reg-no" disabled={this.state.disabled}>{this.state.regNum}</div>
			<div className="cac-name li-name" disabled={this.state.disabled}>{this.state.name}</div>
			<div className="cac-step2-area li-step2-area">
				<input type="text" placeholder={this.state.areaPlanted} onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,4}?$/
					const isValid = checker.test(e.target.value)
					if(isValid) {
						this.state.member["area_planted"] = e.target.value
						this.props.handler("step2", this.state.farmerId, this.state.member)
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({areaPlanted: null})
							e.target.value = "";
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} disabled={this.state.disabled} />
			</div>
			<div className="cac-step2-commitment li-step2-commitment">
				<input type="text" placeholder={this.state.initialCommitment} onChange={(e) => {
					const checker = /^[0-9]+$/;
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.member["initial_commitment"] = e.target.value
						this.props.handler("step2", this.state.farmerId, this.state.member)
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({initialCommitment: null})
							e.target.value = "";
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} disabled={this.state.disabled} />
			</div>
			<div className="cac-step4 li-step4">
				<input type="text" placeholder={this.state.supplyCommitment} onChange={(e) => {
					const checker = /^[0-9]+$/;
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.member["supply_commitment"] = e.target.value
						this.props.handler("step4", this.state.farmerId, this.state.member)
						const nm = (e.target.value >= this.state.evaluatedSupply)? true: false
						this.setState({notMet: nm, supplyCommitment: e.target.value})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({supplyCommitment: null})
							e.target.value = "";
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} disabled={this.state.disabled} />
			</div>
			<div className="cac-step6 li-step6"><div className="li-step6-switch">
				{/* <div><SwitchWidget isOn={this.state.notMet} view={this.props.view} onToggle={(v) => {
				}} isDisabled={this.state.disabled} /></div>
				<div>Not Met?</div>
				<div> */}
				<input type="text" placeholder={this.state.evaluatedSupply} onChange={(e) => {
					const checker = /^[0-9]+$/;
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.member["evaluated_supply"] = e.target.value
						this.props.handler("step6", this.state.farmerId, this.state.member)
						const nm = (this.state.supplyCommitment >= e.target.value)? true: false
						this.setState({notMet: nm, evaluatedSupply: e.target.value})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({evaluatedSupply: null})
							e.target.value = "";
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} disabled={this.state.disabled} />
				{/* </div> */}
			</div></div>
		</div>
		return(view)
	}
}

export default SupplyPlanCommitment
